import { isAuthorized } from '@/config/Auth'
import { useAuth } from '@/hooks/useAuth'
import { Navigate } from 'react-router'

export function ProtectedRoute({ scopes, component: Component }) {
  const { activeViews } = useAuth()

  if (!activeViews || !isAuthorized(activeViews, scopes)) {
    return <Navigate to={{ pathname: '/' }} />
  }

  return <Component />
}
